import { createContext, useContext } from 'react'

/** The living billing-summary asset the entries UI renders against. */
export type MedSummaryParentContextValue = {
  // Asset id — entries/references store keys and the entry edit endpoint route on this
  id: string
  // Collaborators can read the summary but not edit it. The backend enforces the same split
  // (member-scoped reads, owner-scoped writes); this only hides the affordances.
  readOnly: boolean
}

const MedSummaryParentContext = createContext<MedSummaryParentContextValue | null>(null)

export const MedSummaryParentProvider = MedSummaryParentContext.Provider

/**
 * The billing-summary asset the current entries UI renders. Cells and popovers use it to key
 * store reads and route entry edits.
 */
export function useMedSummaryParent(): MedSummaryParentContextValue {
  const context = useContext(MedSummaryParentContext)
  if (!context) throw new Error('useMedSummaryParent must be used within a MedSummaryParentProvider')
  return context
}
